module.exports = "/packs/images/forms/form-select-arrow~7549bcd2c9866f46b5ab3cb892381f83.png";